module.exports = __webpack_public_path__ + "static/media/github.629e1ab5.svg";